(() => {
  if(window.ppScoopHeroReady)return;
  window.ppScoopHeroReady=true;
  const states=new WeakMap();
  const init=root=>{
    if(states.has(root))return;
    const video=root.querySelector('[data-pp-scoop-video]');
    if(!video)return;
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible=false;
    const update=()=>{
      if(!visible||motion.matches||document.hidden)video.pause();
      else video.play().catch(()=>{});
    };
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:.1});
    observer.observe(video);
    motion.addEventListener('change',update);
    document.addEventListener('visibilitychange',update);
    states.set(root,()=>{
      observer.disconnect();video.pause();
      motion.removeEventListener('change',update);
      document.removeEventListener('visibilitychange',update);
      states.delete(root);
    });
  };
  const scan=scope=>{
    if(scope.matches?.('[data-pp-scoop-section]'))init(scope);
    scope.querySelectorAll('[data-pp-scoop-section]').forEach(init);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-pp-scoop-section]').forEach(root=>states.get(root)?.()));
})();
